module.exports = __webpack_public_path__ + "static/16-644333de2d264a325441ed6560bcd345.jpg";